import { render, staticRenderFns } from "./VUploadUserIds.vue?vue&type=template&id=203a63b0&scoped=true"
import script from "./VUploadUserIds.vue?vue&type=script&lang=ts"
export * from "./VUploadUserIds.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203a63b0",
  null
  
)

export default component.exports